/*
 * Copyright (c) Harness Inc.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export default {
  noResult: 'No results.',
  newTag: (newTag: string) => `Create "${newTag}"`,
  addTag: '+ tag'
}
